export default __webpack_public_path__ + "static/media/IMG_6760-Copy.5b9549d6.jpg";